import { hasPageLoadingEnded, native } from '@forest/native-services'

/**
 * The existing daily close, run once as a startup operation's terminal outcome.
 *
 * A page that has already been left runs nothing: its close has happened and a
 * late failure must neither close again nor reach the successor page. Content
 * loading and product initialization are separate operations that share this
 * one terminal close, so whichever exhausts its recovery first closes the
 * presentation and the other cannot close it again.
 */
export function closeAfterStartupFailure(): void {
  if (hasPageLoadingEnded()) return
  native.general.close()
}
